import api from '@/modules/api.service';
import type { RelatorioAtividadeDto } from '../relatorios-atividades.types';
import { mapRelatorioDetalhe } from './relatorios-atividades.mappers';

export async function buscarRelatorioPorIdUseCase(id: number): Promise<RelatorioAtividadeDto | null> {
  try {
    const response = await api.get(`/relatorios/atividades/${id}`);
    const relatorio = response.data;

    if (!relatorio) return null;

    return mapRelatorioDetalhe(relatorio);
  } catch (error) {
    console.error('Erro ao buscar relatório por ID:', error);
    return null;
  }
}
